module.exports = __webpack_public_path__ + "img/banner.ac14705c.jpg";